import * as _ from 'underscore';
import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { EditWorkbookAction } from '../../../actions/spaces/EditWorkbookAction';
import { openBlankWindow, setWindowLocation } from '../SpacesSagaHelpers';
import { fetchWorkbookById } from './WorkbookSagas';
import { ExtractDraftAvaliableDialog } from '../../../../extract/components/ExtractDraftAvaliableDialog';

// When a new window is created, if it's not part of a click event handler it will be detected by browsers as a pop-up.
// Because we are opening a new window in the edit workbook saga which is async, to get around the pop up blocker we need
// to open the window first, then the window.location.href can be set asynchronously afterwards
export function* handleEditWorkbookAction(action: EditWorkbookAction) {
  let newWindow: Window = null;
  try {
    const workbookInfo = yield call(fetchWorkbookById, action.workbook.id);
    let userExtractDraft = false;
    if (!_.isUndefined(workbookInfo.editExtractDraftUrl)) {
      userExtractDraft = yield call(ExtractDraftAvaliableDialog.open);
    }
    newWindow = openBlankWindow();
    if(userExtractDraft) {
      setWindowLocation(newWindow, workbookInfo.editExtractDraftUrl);
    } else {
      setWindowLocation(newWindow, workbookInfo.editUrl);
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
